import extent from './extent.reducer';

export default extent;
